import React from 'react';
import PropTypes from 'prop-types';

class Tag extends React.Component {

  static propTypes = {
    afterSelectRow: PropTypes.func.isRequired,
  }

  state = {
    visible: false,
    tag: new Monet.UI.Fields.Render({
      name: 'tags',
      mandatory: false,
      type: 'LOOKUP',
      lookupEntity: 'Tag',
      lookupEntityColumn: 'description',
    }, 'RouteMonitor').render(),
  }

  componentDidMount() {
    const el = this.state.tag.rootEl;
    el.children[2].children[0].firstElementChild.placeholder = Monet.I18n.getResourcesByKey('RouteMonitor.filter.searchTags');
    this.state.tag.addListenerToAfterSelectRow(this.search);
    this.refs.tag.appendChild(el);
  }

  componentDidUpdate() {
    if (!this.state.visible) {
      this.state.tag.clear();
    }
    return true;
  }

  search = ({ id }) => {
    const { afterSelectRow } = this.props;
    afterSelectRow('tagId', id);
  }

  updateState(visible) {
    this.setState({
      ...this.state,
      visible,
    });
  }

  render() {
    const display = (this.state.visible) ? 'inline-flex' : 'none';
    const styles = {
      display,
    };
    return (
      <div ref="tag" style={styles} />
    );
  }
}

export default Tag;
